import React from 'react'
import { Cliente } from '../../types'
import Modal from '../Modal'
import ClienteForm from './ClienteForm'

interface ClienteModalProps {
  isOpen: boolean
  onClose: () => void
  cliente?: Cliente
  onSave: (cliente: Cliente) => void
  isLoading?: boolean
}

const ClienteModal: React.FC<ClienteModalProps> = ({
  isOpen,
  onClose,
  cliente,
  onSave,
  isLoading = false
}) => {
  const handleSave = (savedCliente: Cliente) => {
    onSave(savedCliente)
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={cliente ? 'Editar Cliente' : 'Novo Cliente'}
      size="2xl"
    >
      <div className="max-h-[80vh] overflow-y-auto">
        <ClienteForm
          cliente={cliente}
          onSave={handleSave}
          onCancel={onClose}
          isLoading={isLoading}
        />
      </div>
    </Modal>
  )
}

export default ClienteModal